import { jsx as _jsx } from "react/jsx-runtime";
const ArrowThinLeft = ({ width = '24', height = '24', fill = '#9CA3AF', }) => {
    return (_jsx("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M7 16L3 12M3 12L7 8M3 12L21 12", stroke: "#9CA3AF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
export default ArrowThinLeft;
